jQuery(document).ready(function($) {
    'use strict';

    var flyout = $('.mobile-menu');
    var button = $('#mobile-nav');
    var header = $('header');
    var body = $('body');


    $(document).on('click', '#mobile-nav', function() {
        flyout.toggleClass('open');
        button.toggleClass('menu-open');
        header.toggleClass('active-menu');
        body.toggleClass('active-mobile-menu');
    });
});

//# sourceMappingURL=mobilemenu.js.map
